import customAxios from '../../customAxios';
import { ACADEMIC_YEAR } from '../../routes';
import { IAcademicYearForm } from '../../../types/academicYear.interface';

async function createAcademicYear(props: IAcademicYearForm) {
  try {
    return (await customAxios.post(ACADEMIC_YEAR, props)).data;
  } catch (error: any) {
    console.error({ ACADEMIC_YEAR: error });
  }
}

export default createAcademicYear;
